import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../Elements/Button/Button';
import { useAuthentication } from '../../Hooks/useAuthentication';
import { appRoutes } from '../../routesConfig';
import './home.css';

export default function Home() {
  const navigate = useNavigate();
  const { role } = useAuthentication();

  // Excluir rutas sin metadata (como DetalleOrden)
  const cards = appRoutes.filter(route => route.title);

  // Filtrar según rol
  const visibleCards = cards.filter(card =>
    card.allowedRoles.length === 0 || card.allowedRoles.includes(role)
  );

  return (
    <div className="home-dashboard container-fluid py-5 container-mh">
      <h1 className="dashboard-title mb-4">Panel de Administración</h1>
      <div className="row g-4">
        {visibleCards.map(card => (
          <div key={card.path} className="col-12 col-md-6 col-lg-3">
            <div className="card dashboard-card h-100 text-center">
              <div className="card-body d-flex flex-column justify-content-between">
                <div>
                  <div className="icon" style={{ fontSize: '48px' }}>{card.icon}</div>
                  <h5 className="card-title mt-3">{card.title}</h5>
                  <p className="card-text text-muted">{card.description}</p>
                </div>
                <Button
                  text={card.buttonText}
                  color={card.color}
                  fill
                  action={() => navigate(card.path)}
                  classNames="mt-3"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}